module.exports = __webpack_public_path__ + "img/tripleedgestudios.876c4ea8.svg";